import { Injectable } from '@angular/core';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { ExameConfiance, ExameLaboratorio } from 'app/core/interfaces/pacient-info.interface';
import { ModalsService } from 'app/shared/modals.service';

@Injectable({
  providedIn: 'root'
})
export class LaboratorioArquivoFlowService {
  constructor(
    private _apiGestaCard: APIGestaCardService,
    private _modalService: ModalsService
  ) {}

  async processarArquivoExistente(params: {
    arquivoId: string;
    trimestre: number;
    examesLab: ExameLaboratorio[];
    dum?: string | Date;
    cartaoId?: string;
    reanalisar?: boolean;
  }): Promise<{ arquivoId: string; examesLaboratorios: ExameLaboratorio[] } | null> {
    const arquivo = await this._apiGestaCard.BuscarArquivoPDF(params.arquivoId);
    if (!arquivo) {
      throw new Error('Arquivo não encontrado.');
    }

    let preAnalisedExams: ExameConfiance[] = [];

    if (params.reanalisar) {
      const reanalise = await this._apiGestaCard.ReAnalisarLaboratorial(params.arquivoId);
      preAnalisedExams = reanalise && Array.isArray(reanalise.exames) ? reanalise.exames : [];
    } else {
      if (arquivo.status === 'pendente') {
        throw new Error('Arquivo pendente precisa ser analisado antes de utilizar.');
      }

      if (!arquivo.resultado) {
        throw new Error('Arquivo sem resultado.');
      }

      preAnalisedExams = Array.isArray(arquivo.resultado)
        ? arquivo.resultado
        : arquivo.resultado.exames || [];
    }

    return this._modalService.UtilizarArquivoAnalisadoLaboratorial(
      params.arquivoId,
      params.trimestre,
      preAnalisedExams,
      params.examesLab,
      params.dum,
      params.cartaoId,
      arquivo.data_realizacao
    );
  }
}
